// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from 'react-redux';
import { baseStore, RootState } from '../store'; // Adjust the import based on your file structure
import Logger from '../helpers/logger';
import ErrorTracker from '../helpers/errorTracker';
import { locationsApiSlice } from '../../api/locations/locationsApiSlice';
import { setAllDepotsByLocation } from '../slice/booking/bookingSlice';
import { notifyLoadFailure, queryResultError } from '../helpers/failureNotification';


const fetchAllDepotsCall = async(locationId: string) => {
    const data = await baseStore.dispatch(
        locationsApiSlice.endpoints.getDepotByLocationId.initiate({
            locationId: locationId,
        })
    )
    return data;
};

export const useFetchAllDepots = () => {
  const locations = useSelector((state: RootState) => state.booking.locations);
  const dispatch = useDispatch();

  const fetchAllDepots = async () => {
    try {
        if (locations && locations.length > 0) {
            const locationIds = locations.map((location: any) => location.id);
            const allDepotsByLocation: { [key: string]: any } = {};
            let failure: unknown;

            // Loop over each locationId and make an API call for each one
            for (const locationId of locationIds) {
                const result = await fetchAllDepotsCall(locationId); // API call for each locationId
                // `initiate` resolves with `{ error }` instead of throwing, so
                // this is the only place a failure is visible at all (#1970).
                failure = failure ?? queryResultError(result);

                if (result.data) {
                    allDepotsByLocation[locationId] = result.data;
                }
            }

            // Dispatch action after all groups are fetched
            dispatch(setAllDepotsByLocation({ depots: allDepotsByLocation }));

            if (failure) {
                // One message for the whole sweep — a station-per-location
                // toast storm says nothing extra.
                Logger.for('fetchAllDepots').error(failure);
                ErrorTracker.trackException(failure as Error);
                notifyLoadFailure(dispatch, 'book_location.error.fetch_depots');
            }
        }
    } catch (error) {
      Logger.for('createNewReservation').error(error);
      ErrorTracker.trackException(error as Error);
      notifyLoadFailure(dispatch, 'book_location.error.fetch_depots');
    }
  };

  return fetchAllDepots;
};
